import axiosInstance from '../api';

interface Data {
  listingId: string;
  leadPaint?: boolean;
  leadPaintExplain?: string;
  formId: number;
  offerId?: string;
  secondSellerName?: string;
  secondSellerEmail?: string;
  addendumTerms?: string;
  // GA document fields
  closingAttorney?: string;
  closingPhone?: string;
  taxParcelId?: string;
  possessionDays?: string;
  possessionTime?: string;
  possessionAmPm?: string;
  atClosing?: boolean;
  attorneyAddress?: string;
  attorneyCityState?: string;
  attorneyFax?: string;
  attorneyEmail?: string;
  // AL purchase agreement form selection + community association (HOA) fields
  alFormVersion?: 'AAR' | 'GALMLS';
  hasHoa?: boolean;
  hoaAddendumNo?: string;
  // VA loan fields
  interestRate?: string;
  contingencyDays?: string;
  fundingFeeOption?: string;
  fundingFeePaidBy?: string;
  repairLimit?: string;
  termiteResponsibility?: string;
  sewerLimit?: string;
}

const formsService = {
  post: async (data: Data) => {
    const res = await axiosInstance.post('/forms', data);
    return res.data;
  },
  get: async (offerId: string) => {
    const res = await axiosInstance.get(`/forms/${offerId}`);
    return res.data;
  },
};

export default formsService;
